import apiClient from '../../../utils/lib/apiClient';
import { loadingState, loadingText } from '../../../states/loadingState';
import { useSetRecoilState } from 'recoil';
import { useCallback } from 'react';
export const useGetHasDiaryList = () => {
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);

  const getHasDiaryList = useCallback(
    async (
      workerNoList: number[],
      workingDate: string
    ): Promise<{ workerId: number; isDiaryExist: boolean }[] | null> => {
      setLoadingAnimation(true);
      setLoadingText('取得中...');
      try {
        const res = await apiClient.get('/rocketForge/posts/hasDiaryList', {
          params: {
            workerNoList: workerNoList.join(','), // 配列をカンマ区切りの文字列に変換
            workingDate,
          },
        });
        const data = res.data.map(
          (item: { workerId: number; isDiaryExist: boolean }) => {
            return {
              workerId: Number(item.workerId),
              isDiaryExist: item.isDiaryExist,
            };
          }
        );
        return data;
      } catch (e) {
        window.alert('エラーが発生しました' + e);
        return null;
      } finally {
        setLoadingAnimation(false);
        setLoadingText('');
      }
    },
    [loadingState, loadingText]
  );

  return { getHasDiaryList };
};
